<template>
  <div class="home">
    <div v-if="isNotCordova">
      <div id="header"><div id="page-title">AzusaDesigner</div></div>
      <div id="eye-catch">
        <h1>ストーリー制作支援</h1>
        <h2>漫画、小説のプロットを編集</h2>
        <button class="btn" @click="goEditor">ブラウザで始める<br><span style="font-size:16px;font-weight:normal">(Windows, OS X, Linux)</span></button>
      </div>
      <div class="section section-even" style="text-align:center">
        <div class="section-inner" style="zoom:1.1">
          <a target="_blank" href='https://play.google.com/store/apps/details?id=net.kmycode.azusadesigner&hl=ja&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Google Play で手に入れよう' src='https://play.google.com/intl/us-en/badges/static/images/badges/ja_badge_web_generic.png' height="60"/></a>
          <a target="_blank" href="https://apps.apple.com/jp/app/azusadesigner/id1524391949?mt=8" style="display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2020-08-05&kind=iossoftware&bubble=apple_music) no-repeat;width:135px;height:40px;margin:12px 0"></a>
        </div>
      </div>
      <div class="section section-odd">
        <div class="section-inner section-inner-image-container">
          <div class="section-inner-image" style="background-image:url(/screenshots_002.png)">
          </div>
          <div class="image-text-block">
            <h2>ストーリーの要素を分類</h2>
            物語に登場する要素を、人物、場所、シーンなどに分類してまとめることができます。<br>
            この分類を「カテゴリ」と呼びます。
          </div>
        </div>
      </div>
      <div class="section section-even">
        <div class="section-inner section-inner-image-container">
          <div class="image-text-block">
            <h2>エンティティを編集</h2>
            カテゴリに分類された要素それぞれを「エンティティ」と呼びます。<br>
            エンティティにはそれぞれ編集項目が存在し、それらを埋めることで物語の設定を記録、整理、管理できます。
          </div>
          <div class="section-inner-image" style="background-image:url(/screenshots_001.png)">
          </div>
        </div>
      </div>
      <div class="section section-odd">
        <div class="section-inner section-inner-image-container">
          <div class="section-inner-image" style="background-image:url(/screenshots_007.png)">
          </div>
          <div class="image-text-block">
            <h2>編集項目をカスタマイズ</h2>
            エンティティの編集項目は、自由にカスタマイズすることができます。<br>
            足りない編集項目があると感じた時は、いつでも思いのままに追加することができます。<br>
            追加可能な編集項目は、数値、日付のほか、色、画像（クラウドのみ）もあります。
          </div>
        </div>
      </div>
      <div class="section section-even">
        <div class="section-inner section-inner-image-container">
          <div class="image-text-block">
            <h2>カテゴリをカスタマイズ</h2>
            足りないカテゴリがあると感じたら、同様に編集することができます。<br>
            自分独自のカテゴリを作成することも可能で、物語の世界観にあった柔軟なカスタマイズが実現できます。
          </div>
          <div class="section-inner-image" style="background-image:url(/screenshots_006.png)">
          </div>
        </div>
      </div>
      <div class="section section-odd">
        <div class="section-inner section-inner-image-container">
          <div class="section-inner-image" style="background-image:url(/screenshots_004.png)">
          </div>
          <div class="image-text-block">
            <h2>小説本文を執筆</h2>
            AzusaDesignerはプロット作成支援を目的としたアプリですが、小説本文の執筆に対応しています。<br>
            カテゴリの一種として小説専用のものを作ることができ、エンティティ編集の要領で文章を書き進めることができます。
          </div>
        </div>
      </div>
      <div class="section section-even">
        <div class="section-inner section-inner-image-container">
          <div class="image-text-block">
            <h2>情報を視覚化</h2>
            このほか、相関図、チャート、時系列（年表）にも対応。<br>
            入力したデータを視覚化することで、全体像を把握、モチベーションにつなげます。
          </div>
          <div class="section-inner-image" style="background-image:url(/screenshots_005.png)">
          </div>
        </div>
      </div>
      <div class="section section-odd">
        <div class="section-inner section-inner-image-container">
          <div class="image-text-block">
            <h2>クラウドで端末間でデータを共有</h2>
            作成したストーリーはローカル（端末内）に保存することも可能ですが、クラウドに保存することで端末間で共有することもできます（※有償）。<br>
            クラウドへの接続もHTTPSで暗号化され、より安全な執筆が可能です。
          </div>
        </div>
      </div>
      <div class="section section-even">
        <div class="section-inner">
          <h2>料金</h2>
          <div style="text-align:center;margin-bottom:16px">
            2020年9月14日までProを無料体験可！
          </div>
          <table border="0" cellspacing="0">
            <tr>
              <th></th>
              <th>Free</th>
              <th>Pro</th>
            </tr>
            <tr>
              <th>価格</th>
              <td>0円</td>
              <td>370円／月</td>
            </tr>
            <tr>
              <th>ローカル</th>
              <td>◯</td>
              <td>◯</td>
            </tr>
            <tr>
              <th>エンティティ編集</th>
              <td>◯</td>
              <td>◯</td>
            </tr>
            <tr>
              <th>カテゴリの<br>カスタマイズ</th>
              <td>◯</td>
              <td>◯</td>
            </tr>
            <tr>
              <th>小説執筆</th>
              <td>◯</td>
              <td>◯</td>
            </tr>
            <tr>
              <th>相関図</th>
              <td>◯</td>
              <td>◯</td>
            </tr>
            <tr>
              <th>チャート</th>
              <td>◯</td>
              <td>◯</td>
            </tr>
            <tr>
              <th>時系列（年表）</th>
              <td>◯</td>
              <td>◯</td>
            </tr>
            <tr>
              <th>クラウド</th>
              <td></td>
              <td>◯</td>
            </tr>
            <tr>
              <th>端末間共有</th>
              <td></td>
              <td>◯</td>
            </tr>
            <tr>
              <th>画像</th>
              <td></td>
              <td>◯</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="section section-odd">
        <div class="section-inner">
          <h2>対応環境</h2>
          Windows、OS X、Linuxはブラウザより始めることができます。そのほか、スマホアプリもあります。（課金はスマホアプリでしかできませんが、課金したアカウントにブラウザからログインすることでPCからもクラウドを利用できます）<br>
          <div style="text-align:center">
            <button class="btn" @click="goEditor" style="width:160px">ブラウザで始める</button><br>
            <a target="_blank" href='https://play.google.com/store/apps/details?id=net.kmycode.azusadesigner&hl=ja&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Google Play で手に入れよう' src='https://play.google.com/intl/us-en/badges/static/images/badges/ja_badge_web_generic.png' height="60"/></a>
            <a target="_blank" href="https://apps.apple.com/jp/app/azusadesigner/id1524391949?mt=8" style="display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2020-08-05&kind=iossoftware&bubble=apple_music) no-repeat;width:135px;height:40px;margin:12px 0"></a>
          </div>
        </div>
      </div>
      <div class="section section-even">
        <div class="section-inner">
          <h2>協力サイト・Special Thanks</h2>
          <p><a target="_blank" href="https://sakka-no-mikata.jp/">★作家の味方｜小説家になりたい人のための専門情報サイト！</a></p>
          <p><a target="_blank" href="https://sousaku-neta.com/">創作ネタまとめ BL男女ネタのヒント〜そうとめ〜</a></p>
          <p><a target="_blank" href="https://app-liv.jp/">Appliv</a> <a target="_blank" href="https://app-liv.jp/1524391949/">レビュー</a></p>
        </div>
      </div>
      <div id="footer">
        <a href="https://twitter.com/azusadesigner" target="_blank">Twitter</a> | <a href="https://note.com/askyqq/m/mb08efa34423d" target="_blank">お知らせ</a><br>
        Copyright (C) Takaki Tanaka (雪あすか) 2020
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class Home extends Vue {
  isNotCordova = false;

  created() {
    if (typeof(cordova) !== 'undefined') {
      this.goEditor();
    } else {
      this.isNotCordova = true;
    }
  }

  goEditor() {
    this.$router.push('/edit');
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/common.scss';

#header {
  height: 44px;
  color: var(--accent-color);
  background: $accent-text-color;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  #page-title {
    flex: 1;
    text-align: center;
    height: 44px;
    line-height: 44px;
    font-weight: bold;
    font-size: 22px;
    cursor: default;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

#eye-catch {
  background: var(--accent-color);
  color: $accent-text-color;
  margin-top: 44px;
  padding-bottom: 32px;
  text-align: center;

  h1 {
    margin: 0;
    padding-top: 48px;
    font-size: 48px;
  }
  h2 {
    font-size: 32px;
    color: var(--second-color);
  }
  button {
    margin-top: 24px;
    font-weight: bold;
    width: 240px;
    height: 80px;
    font-size: 20px;
    line-height: 24px;
  }
}

.section {
  padding: 16px 0;

  &.section-even {
    background: var(--second-color);
  }

  &.section-odd {
    background: var(--third-color);
  }

  h1,h2,h3,h4 {
    text-align: center;
  }

  table {
    width: 80%;
    margin: 0 auto 24px;
    border-right: 1px solid #bbb;
    border-bottom: 1px solid #bbb;
    border-radius: 16px;
    overflow: hidden;

    @media screen and (max-width: 600px) {
      width: 100%;
    }

    th, td {
      padding: 16px;
      border-left: 1px solid #bbb;
      border-top: 1px solid #bbb;
      text-align: center;
    }
    th {
      background: var(--accent-color);
      color: $accent-text-color;
    }
    td {
      background: white;
    }
    tr th:first-child {
      background: var(--second-dark-color);
      color: var(--base-text-color);
    }
    tr:first-child th:first-child {
      background: none;
    }
  }
}

.section-inner {
  width: 800px;
  max-width: 90vw;
  margin: 0 auto;

  &.section-inner-image-container {
    display: flex;
    align-items: center;

    h2 {
      margin-top: 0;
    }

    @media screen and (max-width: 600px) {
      min-height: auto;
      flex-direction: column;
      h2 {
        margin-top: 16px;
      }
    }

    .section-inner-image {
      background-repeat: no-repeat;
      background-size: cover;
      flex: 0.7;
      margin: 0 32px;
      min-width: 200px;
      min-height: 500px;

      @media screen and (max-width: 600px) {
        min-height: 300px;
        margin: 0;
      }
    }

    .image-text-block {
      flex: 1;
      min-width: 200px;
      margin-bottom: 16px;
    }
  }
}

@media screen and (max-width: 600px) {
  .section-even .section-inner-image-container {
    flex-direction: column-reverse;
  }
}

#contents {
  width: 80vw;
  max-width: 800px;
  margin: 36px auto;
  h2, h3 {
    text-align: center;
  }
}

#footer {
  text-align: center;
  margin-top: 36px;
  margin-bottom: 24px;
  color: #aaa;
  a {
    color: #777;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
